import { exists } from '@/api'

export interface AuthorityDetailTag {
  id: number
  tagGroup: string
  tag: string
  menuDisplay: number
  displayOrder: number
  labelName: string
  repeat: boolean
  fieldType: string
  layoutType: string
  maxLength: number
  systemCodeKeyKey: string
}

export const defaultAuthorityDetailTag = (): AuthorityDetailTag => ({
  id: 0,
  tagGroup: '',
  tag: '',
  menuDisplay: 0,
  displayOrder: 0,
  labelName: '',
  repeat: false,
  fieldType: '',
  layoutType: '',
  maxLength: 0,
  systemCodeKeyKey: ''
})

export function AuthorityDetailTagFromJSON(json: any): AuthorityDetailTag {
  return {
    id: exists(json, 'id') ? json.id : 0,
    tagGroup: exists(json, 'tag_group') ? json.tag_group : '',
    tag: exists(json, 'tag') ? json.tag : '',
    menuDisplay: exists(json, 'menu_display') ? json.menu_display : 0,
    displayOrder: exists(json, 'display_order') ? json.display_order : 0,
    labelName: exists(json, 'label_name') ? json.label_name : '',
    repeat: exists(json, 'repeat') ? json.repeat : false,
    fieldType: exists(json, 'field_type') ? json.field_type : '',
    layoutType: exists(json, 'layout_type') ? json.layout_type : '',
    maxLength: exists(json, 'max_length') ? json.max_length : 0,
    systemCodeKeyKey: exists(json, 'system_code_key_key')
      ? json.system_code_key_key
      : ''
  }
}
